import React, {useEffect, useState} from 'react'
import {useTranslation} from "react-i18next";
import { ReactComponent as BTCLoader } from '../../../assets/icons/main/bitkoinLoading.svg'
import OrderList from './OrderList'
import Button from '../../../components/button/Button'
import axios from "axios";
import useIsMobile from '../useIsMobile'
import './Orders.css'

const Orders = ({setStateBuyOrder, setOrderType}) => {
    const {t} = useTranslation();
    const isMobile = useIsMobile();
    const token = localStorage.getItem('token')
    const url = new URL(window.location.href);
    let symbolURL = (url.searchParams.get('symbol')) || "BTCUSDT";
    let match = symbolURL.match(/(\w+)(USDT|BTC|BNB)/);


    let BalanceID = ""
    if (symbolURL.length === 7){
        BalanceID = symbolURL[0].toLowerCase() + symbolURL[1].toLowerCase() + symbolURL[2].toLowerCase();
    }
    else{
        BalanceID = symbolURL[0].toLowerCase() + symbolURL[1].toLowerCase() + symbolURL[2].toLowerCase() + symbolURL[3].toLowerCase();
    }

    const [isLoadedOrdersTable, setIsLoadedOrdersTable] = useState(false)
    
    const [userOrdersClose, setUserOrdersClose] = useState([])
    const [userOrdersClosedTotal, setUserOrdersClosedTotal] = useState(0)

    const [userOrdersWaiting, setUserOrdersWaiting] = useState([])
    const [userOrdersWaitingTotal, setUserOrdersWaitingTotal] = useState(0)

    const [userOrdersOpen, setUserOrdersOpen] = useState([])
    const [userOrdersOpenTotal, setUserOrdersOpenTotal] = useState(0)

    const [userBalance, setUserBalance] = useState()
    const [AVGdata, setAVGdata] = useState([])

    // const [loaderStatus, setLoaderStatus] = useState(false)

    // const requireAVGdata = () => axios.get(`https://api.binance.com/api/v3/ticker/24hr?symbol=${symbolURL}`)
    //     .then(res => {
    //         setAVGdata(res.data);
    //         setTimeout(() => requireAVGdata(), 2000)
    //     })
    const requireAVGdata = () => null
    const requireUserBalance = () => axios.get(
        `https://api-ru.fynex.cc/api/api/users/balance/futures`,
        {
            headers: {"Authorization" : `Bearer ${token}`}
        })
        .then(res => {
            // console.log(match[1].toLowerCase())
            // console.log("res.data[0]")
            // console.log(res.data[0])
            // console.log("------")
            setUserBalance(res.data[`${match[1].toLowerCase()}`]);
        });

    const requireUserDataClosed = () => axios.get(
        `https://api-ru.fynex.cc/orders/api/order/close?size=50&page=${1}`,
        {
            headers: {"Authorization" : `Bearer ${token}`}
        })
        .then(res => {
            setUserOrdersClose(res.data.items);
            setUserOrdersClosedTotal(res.data.total);
            // console.log(res.data)
        })
    const requireUserDataWaiting = () => axios.get(
        `https://api-ru.fynex.cc/orders/api/order/waiting?size=50&page=${1}`,
        {
            headers: {"Authorization" : `Bearer ${token}`}
        })
        .then(res => {
            setUserOrdersWaiting(res.data.items);
            setUserOrdersWaitingTotal(res.data.total);
            // console.log(res.data)
        })

    const requireUserDataOpen = () => {
        axios.get(
            `https://api-ru.fynex.cc/orders/api/order/open?size=50&page=${1}`,
            {
                headers: {"Authorization" : `Bearer ${token}`}
            })
            .then(res => {
                setIsLoadedOrdersTable(true)         
                // setLoaderStatus(true)
                setUserOrdersOpen(res.data.items);
                setUserOrdersOpenTotal(res.data.total);
                // console.log(res.data)
            });
    }
    useEffect(() => {
        requireUserDataOpen()
        requireUserDataClosed()
        requireUserDataWaiting()
        const openId = setInterval(requireUserDataOpen, 3000)
        const closeId = setInterval(requireUserDataClosed, 3000)
        const waitId = setInterval(requireUserDataWaiting, 3000)
        return () => {
            clearInterval(openId)
            clearInterval(closeId)
            clearInterval(waitId)
        }
    }, [])

    const [activeList, setActiveList] = useState(1)

    useEffect(() => {
        // console.log(activeList)
    }, [activeList]);


    const [open, setOpen] = useState(true);
    const [x, setX] = useState(false);
    const [historyOrders, setHistoryOrders] = useState(1);
    const [elems, setElems] = useState([])
    const [oldCache, setOldCache] = useState({})
    const [cache, setCache] = useState({});
    useEffect(() => {
        requireUserBalance();
        Promise.all(
            userOrdersOpen.map(async (ordersTable) => {
                const coinPair = `${ordersTable.coin_to}${ordersTable.coin_from.toUpperCase()}`;
                // Проверяем, есть ли данные в кеше

                if (coinPair in cache) {
                    const cr = cache[coinPair];
                    const result = (
                        <OrderList
                            key={ordersTable.id}
                            pnl={ordersTable.pnl}
                            isOpen={true}
                            pnlPercent={ordersTable.pnl_percent}
                            size={cr * ordersTable.amount * ordersTable.leverage}
                            margin={cr * ordersTable.amount}
                            price_admin={ordersTable.price_admin}
                            tpslEdit={true}
                            closeButton={true}
                            isLong={ordersTable.short_long}
                            avg={cr}
                            date={ordersTable.time}
                            price={ordersTable.price}
                            coin={ordersTable.coin_to}
                            coinfrom={ordersTable.coin_from}
                            amount={ordersTable.amount}
                            filled={ordersTable.filled}
                            total={ordersTable.total}
                            action={ordersTable.action}
                            id={ordersTable.id}
                            leverage={ordersTable.leverage}
                            takeProfit={ordersTable.take_profit}
                            stopLoss={ordersTable.stop_loss}
                            requireUserData={requireUserDataOpen}
                            requireUserBalance={requireUserBalance}
                        />
                    );
                    return result;
                }
                try {
                    
                    const res = await axios.get(`https://api-ru.fynex.cc/charts/api/24hr/${coinPair}`);

                    const cacheResult = res.data.lastPrice;
                    const result = (
                        <OrderList
                            key={ordersTable.id}
                            pnl={ordersTable.pnl}
                            isOpen={true}
                            pnlPercent={ordersTable.pnl_percent}
                            price_admin={ordersTable.price_admin}
                            size={res.data.lastPrice * ordersTable.amount * ordersTable.leverage}
                            margin={res.data.lastPrice * ordersTable.amount}
                            tpslEdit={true}
                            margin2={res.data.lastPrice * ordersTable.amount}
                            closeButton={true}
                            isLong={ordersTable.short_long}
                            avg={res.data.lastPrice}
                            date={ordersTable.time}
                            price={ordersTable.price}
                            coin={ordersTable.coin_to}
                            coinfrom={ordersTable.coin_from}
                            amount={ordersTable.amount}
                            filled={ordersTable.filled}
                            total={ordersTable.total}
                            action={ordersTable.action}
                            id={ordersTable.id}
                            leverage={ordersTable.leverage}
                            takeProfit={ordersTable.take_profit}
                            stopLoss={ordersTable.stop_loss}
                            requireUserData={requireUserDataOpen}
                            requireUserBalance={requireUserBalance}
                        />
                    );

                    // Сохраняем данные в кеш
                    setCache({ ...cache, [coinPair]: cacheResult });
                    
                    return result;
                } catch (error) {
                    console.error(`${t("ordser.errorResp")} ${coinPair}: ${error}`);
                    return null;
                }
            })
        ).then((result) => {
            setElems(result.filter((elem) => elem !== null));
            setCache({})
        });
    }, [userOrdersOpen]);


  // Шапка колонок нужна только таблице на десктопе; в мобильной версии ордера — карточки
  const orderNames = isMobile ? null : (
      <ul className='orderNames'>
          <li>{t('orderList.symb')}</li>
          <li>{t('orderList.size')}</li>
          <li>{t('orderList.entryPrice')}</li>
          <li>{t('orderList.margin')}</li>
          <li>{t('orderList.liquidationPrice')}</li>
          <li>{t('orderList.pnlRoe')}</li>
          <li>{t('orderList.takeProfit')}</li>
          <li>{t('orderList.stopLoss')}</li>
      </ul>
  )

  const loader = (
      <div className='LoaderMain'>
          <BTCLoader />
      </div>
  )

  const emptyList = (secondLine) => (
      <div className="nullListsWrapper">
          <span className='nullLists'>{t("ordser.visibleOpenOrder1")}<br/>{secondLine}</span>
      </div>
  )

  // Long / Short открывают шторку BuyOrder (в мобильной версии форма ордера не встроена в страницу)
  const openBuyOrder = (orderType) => {
      if (typeof setOrderType === 'function') setOrderType(orderType)
      if (typeof setStateBuyOrder === 'function') setStateBuyOrder(true)
  }

  return (
    <div className={isMobile ? 'Orders Orders--mobile' : 'Orders'}>

        <div className="orders-menu">
            <span onClick={() => setActiveList(1)} className={activeList === 1 ? "orders-menu-active" : ""} >
                <p className='p-activ'>{t("ordser.openOrder")} ({userOrdersOpenTotal ? userOrdersOpenTotal : "0"})</p>
                <div className="line line-active"></div>
            </span>
            <span onClick={() => setActiveList(2)} className={activeList === 2 ? "orders-menu-active" : ""} >
                <p>{t("ordser.historyOrders")}({userOrdersClosedTotal ? userOrdersClosedTotal : "0"})</p>
                <div className="line"></div>
            </span>
            <span onClick={() => setActiveList(3)} className={activeList === 3 ? "orders-menu-active" : ""} >
                <p>{t("ordser.awaitOrders")}({userOrdersWaitingTotal ? userOrdersWaitingTotal : "0"})</p>
                <div className="line"></div>
            </span>
        </div>

        {activeList === 1 && <div className='order-list'>
            {isLoadedOrdersTable ?
                <ul>
                    {orderNames}
                    {elems.length == 0 ? emptyList(t("ordser.visibleOpenOrder2")) : elems}
                </ul>
            : loader}
        </div>}

        {activeList === 2 && <div className='order-list OrderListHistory'>
            {isLoadedOrdersTable ?
                <ul>
                    {orderNames}
                    {userOrdersClose.length == 0 ?
                        emptyList(t("ordser.historyOrders"))
                    :
                    userOrdersClose.map(ordersTable=>
                        <OrderList
                            key={ordersTable.id}
                            closed={true}
                            waiting={false}
                            size={ordersTable.margin * ordersTable.leverage}
                            avg={AVGdata.lastPrice}
                            date={ordersTable.time}
                            isLong={ordersTable.short_long}
                            price={ordersTable.price}
                            coin={ordersTable.coin_to}
                            coinfrom={ordersTable.coin_from}
                            amount={ordersTable.amount}
                            filled={ordersTable.filled}
                            total={ordersTable.total}
                            action={ordersTable.action}
                            id={ordersTable.id}
                            chlen={true}
                            marzha={ordersTable.margin}
                            wasOpen={ordersTable.was_opened}
                            pnl={ordersTable.pnl}
                            pnlPercent={ordersTable.pnl_percent}
                            leverage={ordersTable.leverage}
                            takeProfit={ordersTable.take_profit}
                            stopLoss={ordersTable.stop_loss}
                            requireUserData={requireUserDataOpen}
                            requireUserBalance={requireUserBalance}
                            histoty={true}
                            time={ordersTable.time}
                            time_closed={ordersTable.time_closed}
                        />)}
                </ul>
            : loader}
        </div>}

        {activeList === 3 && <div className='order-list'>
            {isLoadedOrdersTable ?
                <ul>
                    {orderNames}
                    {userOrdersWaiting.length == 0 ?
                        emptyList(t("ordser.visibleOpenOrder3"))
                    :
                    userOrdersWaiting.map(ordersTable=>
                        <OrderList
                            key={ordersTable.id}
                            closed={false}
                            waiting={true}
                            size={ordersTable.margin * ordersTable.leverage}
                            avg={AVGdata.lastPrice}
                            date={ordersTable.time}
                            isLong={ordersTable.short_long}
                            price={ordersTable.price}
                            coin={ordersTable.coin_to}
                            coinfrom={ordersTable.coin_from}
                            amount={ordersTable.amount}
                            filled={ordersTable.filled}
                            total={ordersTable.total}
                            action={ordersTable.action}
                            id={ordersTable.id}
                            chlen={true}
                            marzha={ordersTable.margin}
                            wasOpen={ordersTable.was_opened}
                            pnl={ordersTable.pnl}
                            pnlPercent={ordersTable.pnl_percent}
                            leverage={ordersTable.leverage}
                            takeProfit={ordersTable.take_profit}
                            stopLoss={ordersTable.stop_loss}
                            requireUserData={requireUserDataOpen}
                            requireUserBalance={requireUserBalance}
                            isOpen={true}
                        />)}
                </ul>
            : loader}
        </div>}

        {/* Long / Short — фиксированная панель внизу, только в мобильной версии */}
        {isMobile && (
            <div className="buttons">
                <Button text={t("ordser.long")}  onClick={() => openBuyOrder(1)}/>
                <Button text={t("ordser.short")} onClick={() => openBuyOrder(2)}/>
            </div>
        )}
    </div>
  )
}

export default Orders
